module.exports = __webpack_public_path__ + "9788f41e/img/sliders-icon.a73c0453.svg";